<template>
	<div class="k-mini-nav">
		<k-tooltip v-for="tab in tabs" :key="tab.id" bottom>
			<template v-slot:activator="{on}">
				<div class="k-mini-nav-btn-outer">
					<div class="k-mini-nav-btn-current-indicator" v-visible="selected_tab == tab.id">
						<k-icon color="primary">
							fas fa-right
						</k-icon>
					</div>

					<k-btn
						v-on="on"
						:class="{ 'k-mini-nav-non-current-btn elevation-0': selected_tab != tab.id }"
						fab x-small
						@click="go_to_home(tab.id, $event)"
						:aria-label="`Open ${tab.title}`"
					>
						<k-icon>{{ tab.icon }}</k-icon>
					</k-btn>
				</div>
			</template>

			{{ tab.title }}
		</k-tooltip>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// current_section will indicate the *type* of *collection* that is currently showing
		current_section: { type: String, required: true },
	},

	data() {
		return  {
			selected_tab: null,
		}
	},
	
	computed: {
		...mapState(['site_config', 'user_info']),

		...mapGetters(['signed_in', 'studentish_role']),

		tabs () {
			let customized_tabs = this.site_config.customized_tabs
			let main_tabs_to_include = this.site_config.main_tabs_to_include

			let defaults = {
				home: {
					id: 'home',
					icon: customized_tabs.home?.icon || (this.role === 'parent' ? 'fa-home-user' : 'fa-home'),
					title: customized_tabs.home?.title || `${this.site_config.app_name} Home`
				},
				classes: {
					id: 'classes',
					icon: customized_tabs.classes?.icon || 'fas fa-chalkboard',
					title: customized_tabs.classes?.title || 'Courses Home'
				},
				resourcerepos: {
					id: 'resourcerepos',
					icon: customized_tabs.resourcerepos?.icon || 'fas fa-diagram-project',
					title: customized_tabs.resourcerepos?.title || `${this.site_config.resourcerepos_noun} Home`
				},
				mycollections: {
					id: 'mycollections',
					icon: customized_tabs.mycollections?.icon || 'fas fa-cubes-stacked',
					title: customized_tabs.mycollections?.title || 'My Content Collections'
				},
				standards: {
					id: 'standards',
					icon: customized_tabs.standards?.icon || 'fas fa-map',
					title: customized_tabs.standards?.title || 'Standards'
				},
			}
			
			let tabs =  []
			
			Object.keys(defaults).forEach(tab => {
				if (tab == 'mycollections') {
					if (!this.studentish_role && (this.signed_in || this.site_config.show_mycollections_when_not_signed_in == 'yes')) {
						tabs.push(defaults.mycollections)
					}
				} else if (main_tabs_to_include.includes(tab)) {
					tabs.push(defaults[tab])
				}
			})
			
			return tabs
		},
	},

	created() {
		switch (this.current_section) {
			case 'my':
				this.selected_tab = 'mycollections'
				break
			case 'repo':
				this.selected_tab = 'resourcerepos'
				break
			case 'course':
				this.selected_tab = 'classes'
				break
			default:
				this.selected_tab = this.current_section
		}
	},
	
	methods: {
		go_to_home(new_section, event) {
			vapp.go_to_home(new_section, event)
		},
	}
}
</script>

<style lang="scss">
.k-mini-nav {
	margin-right: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: $page-background;
	height: 168px;
	border-radius: 16px 0 0 16px;
	padding: 12px 24px 12px 6px;

	.k-mini-nav-btn-outer {
		display: flex;
		align-items: center;
	}

	.k-mini-nav-btn-current-indicator {
		margin-right: 4px;

		.fas {
			font-size: 16px;
		}
	}

	.v-btn {
		margin: 2px -16px 2px 0;
		border: 1px solid #000;
		width: 28px;
		height: 28px;

		.fas, .far {
			font-size: 14px !important;
		}
	}

	.k-mini-nav-home-btn {
		border-color: transparent;
		background-color: transparent !important;

		.fas, .far {
			font-size: 22px !important;
		}
	}
	
	.k-mini-nav-non-current-btn {
		border-color: transparent;
		background-color: #fff !important;
		color: #fff !important;
	}
}

.k-mini-nav-site-section-heading {
	text-align: center;
	font-weight: 900;
	font-size: 16px;
	line-height: 16px;
	color: #333;
	text-transform: uppercase;
	margin: 12px 0 -2px 0;
}
</style>
